module.exports = __webpack_public_path__ + "img/percents-bordered.e5a0e5ee.svg";